var $coroutine, $isArray, JsonRpcError, delete_, format, invalidParameters, migrate, parseSize, ref1, set;

$coroutine = require('bluebird').coroutine;

format = require('json-rpc-peer').format;

invalidParameters = require('xo-common/api-errors').invalidParameters;

ref1 = require('../utils'), $isArray = ref1.isArray, parseSize = ref1.parseSize;

JsonRpcError = require('json-rpc-peer').JsonRpcError;

delete_ = $coroutine(function*(arg) {
  var vdi;
  vdi = arg.vdi;
  yield this.getXapi(vdi).deleteVdi(vdi._xapiId);
});

delete_.params = {
  id: {
    type: 'string'
  }
};

delete_.resolve = {
  vdi: ['id', ['VDI', 'VDI-snapshot'], 'administrate']
};

exports["delete"] = delete_;

set = $coroutine(function*(params) {
  var field, fields, i, len, param, ref, ref2, ref3, size, vdi, xapi;
  vdi = params.vdi;
  xapi = this.getXapi(vdi);
  ref = vdi._xapiRef;
  if ('size' in params) {
    size = parseSize(params.size);
    if (size < vdi.size) {
      throw invalidParameters("cannot set new size (" + size + ") below the current size (" + vdi.size + ")");
    }
    yield xapi.resizeVdi(ref, size);
  }
  ref2 = {
    'name_label': 'name_label',
    'name_description': 'name_description'
  };
  for (param in ref2) {
    fields = ref2[param];
    if (!(param in params)) {
      continue;
    }
    ref3 = ($isArray(fields) ? fields : [fields]);
    for (i = 0, len = ref3.length; i < len; i++) {
      field = ref3[i];
      yield xapi.call("VDI.set_" + field, ref, "" + params[param]);
    }
  }
  return true;
});

set.params = {
  id: {
    type: 'string'
  },
  name_label: {
    type: 'string',
    optional: true
  },
  name_description: {
    type: 'string',
    optional: true
  },
  size: {
    type: ['integer', 'string'],
    optional: true
  }
};

set.resolve = {
  vdi: ['id', ['VDI', 'VDI-snapshot'], 'administrate']
};

exports.set = set;

migrate = $coroutine(function*(arg) {
  var sr, vdi, xapi;
  vdi = arg.vdi, sr = arg.sr;
  xapi = this.getXapi(vdi);
  yield xapi.moveVdi(vdi._xapiRef, sr._xapiRef);
  return true;
});

migrate.params = {
  id: {
    type: 'string'
  },
  sr_id: {
    type: 'string'
  }
};

migrate.resolve = {
  vdi: ['id', ['VDI', 'VDI-snapshot'], 'administrate'],
  sr: ['sr_id', 'SR', 'administrate']
};

exports.migrate = migrate;

Object.defineProperty(exports, '__esModule', {
  value: true
});
